import { getEntityTemplateLang } from '~services/entity-definitions/helpers';
import { createTemporaryEntityId } from '~services/entity-definitions/template-helpers';

export default () => {
  const itemId = createTemporaryEntityId();
  return {
    data: {
      type: 'paragraph--tabs',
      id: createTemporaryEntityId(),
      attributes: {
        langcode: getEntityTemplateLang(),
        status: true,
        default_langcode: true,
        field_hide_title: false,
        field_search_text: null,
        field_title: { value: 'I am a Tabs Module', format: 'rich_text' },
        field_padding_top: null,
        field_padding_bottom: null,
      },
      relationships: {
        field_items: {
          data: [
            {
              type: 'paragraph--tabs_item',
              id: itemId,
            },
          ],
        },
        field_tags: {
          data: [],
        },
      },
      links: {},
      log: [],
      permissions: {
        update: true,
        create: true,
        delete: true,
      },
    },
    included: [
      {
        type: 'paragraph--tabs_item',
        id: itemId,
        attributes: {
          langcode: getEntityTemplateLang(),
          status: true,
          default_langcode: true,
          field_search_text: null,
          field_title: { value: 'I am a Tabs Item', format: 'rich_text' },
        },
        relationships: {
          field_modules: {
            data: [],
          },
          field_tags: {
            data: [],
          },
        },
        links: {},
        permissions: {
          update: true,
          create: true,
          delete: true,
        },
      },
    ],
  };
};
